import { Icon } from '@components';
import ModalV2 from '@layouts/modal/Modal.v2';

interface DuplicateAdmissionModalProps {
  isOpen: boolean;
  admissionNumber?: string;
  isAdmissionNumberError?: boolean;
  isLoading?: boolean;
  onCancel: () => void;
  onProceed: () => void;
}

const DuplicateAdmissionModal = ({
  isOpen,
  admissionNumber,
  isAdmissionNumberError = false,
  isLoading,
  onCancel,
  onProceed
}: DuplicateAdmissionModalProps) => {
  const admissionNumberError = `A member with admission number ${admissionNumber} already exists. Continuing will update the existing member's details with the new information.`;
  const memberError =
    'This member already exists. Continuing will update the existing member\u2019s details with the new information.';
  const confirmText = 'Are you sure you want to continue?';

  if (!isOpen) return null;

  return (
    <ModalV2
      title="Member already exists!"
      onClose={onCancel}
      className="max-w-118"
      primaryButtonLabel="Proceed"
      primaryButtonClick={onProceed}
      primaryButtonLoading={isLoading}
      secondaryButtonLabel="Cancel"
      secondaryButtonClick={onCancel}
      showCloseButton={false}
    >
      <div className="flex flex-col items-center">
        <Icon name="warning-red" size="48" className="mb-5" />
        <p className="text-cofeeNuetral8 text-center">
          {isAdmissionNumberError ? admissionNumberError : memberError}
        </p>
        <p className="text-cofeeNuetral8 text-center">{confirmText}</p>
      </div>
    </ModalV2>
  );
};

export default DuplicateAdmissionModal;
